import { apiClient } from './client';

export const leadAcademyApi = apiClient.injectEndpoints({
    endpoints: (builder) => ({
        getLeadAcademy: builder.query<any, { school_id: any }>({
            query: ({ school_id }) => {
                return {
                    url: `api/leadAcademy?school_id=${school_id}`
                }
            },
        }),
    }),
});

export const { useGetLeadAcademyQuery } = leadAcademyApi;
export default leadAcademyApi;
